import { Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import type { Theme } from '@mui/material/styles'
import { styled } from '@mui/material/styles'
import { type CSSProperties } from 'react'
import { red } from '../../../colors'

interface TitleProps {
  theme?: Theme
}

export const Title = styled(Typography)<TitleProps>(({ theme }) => ({
  fontWeight: 500,
  color: grey[600]
}))
interface TextProps {
  theme?: Theme
}

export const Text = styled(Typography)<TextProps>(({ theme }) => ({
  fontWeight: 500
}))

export const WarningStyles: CSSProperties = {
  backgroundColor: red[0],
  transition: 'background-color 300ms ease-in'
}

export const detailLinkStyle: CSSProperties = {
  color: 'inherit',
  textDecoration: 'none'
}
